import Footer from "../components/Footer";
import Header from "../components/Header";
//import RelatedProducts from "@/components/otherPages/RelatedProducts";
import ShopCart from "./ShopCart";
import React from "react";
import { Link } from "react-router-dom";
import MetaComponent from "../components/MetaComponent";

const metadata = {
    title: `View Cart || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function CartPage({ onPageReady }) {
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <>
                {/* Breadcrumb */}
                <div className="tf-breadcrumb">
                    <div className="container">
                        <ul className="breadcrumb-list">
                            <li className="item-breadcrumb">
                                <Link to={`/`} className="text">
                                    Home
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span />
                            </li>
                            <li className="item-breadcrumb">
                                <span className="text">Cart</span>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Title Page */}
                <section className="page-title">
                    <div className="container">
                        <div className="box-title text-center justify-items-center">
                            <h4 className="title">Shopping Cart</h4>
                        </div>
                    </div>
                </section>
                {/* /Title Page */}
                <div className="flat-spacing-2">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-4 col-sm-8">
                                <div className="tf-cart-head text-center">
                                    <p className="text-xl-3 title text-dark-4">
                                        <span className="fw-medium">Free Shipping</span>
                                    </p>
                                    <div className="progress-sold tf-progress-ship">
                                        <div
                                            className="value"
                                            style={{ width: "0%" }}
                                            data-progress={85}
                                        >
                                            <i className="icon icon-car" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            <ShopCart onLoaded={() => onPageReady?.()} />
            {/*<RelatedProducts />*/}
            <Footer />
        </>
    );
}
